// Keep the masthead dateline accurate.
//
// Ghost renders the date server-side, but pages are cached (by Ghost,
// by a CDN, or both), so a page rendered on Monday can be served on
// Tuesday. This refreshes the text with the reader's local date.
export default function dateline() {
    const el = document.querySelector("[data-dateline]");
    if (!el) return;

    const now = new Date();
    const lang = document.documentElement.lang || undefined;

    try {
        el.textContent = new Intl.DateTimeFormat(lang, {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric"
        }).format(now);
        el.setAttribute("datetime", now.toISOString().slice(0, 10));
    } catch (e) {
        // Leave the server-rendered date in place
    }
}
